export class Nivel {    
    constructor(public id: number,
        public descricao: string){}
}